<template>
  <article :class="{ 'is-closed': !isOpen }">
    <slot />
  </article>
</template>

<script lang="ts" setup>
import { provide, ref } from "vue";

const isOpen = ref(false);

const toogle = () => {
  isOpen.value = !isOpen.value;
};

provide("toggleFaq", toogle);
provide("isFaqOpen", isOpen);
</script>
